import {z} from 'zod';

export const RequestMeta = z.object({
  currentPage: z.coerce.number(),
  lastPage: z.coerce.number(),
  path: z.string(),
  perPage: z.coerce.number(),
  total: z.coerce.number(),
});

export type RequestMeta = z.infer<typeof RequestMeta>;
